import type { FunctionComponent, ReactNode } from 'react';

import type { EvalPasswordStrengthResT } from 'utils';

import { CheckItem } from './CheckItem';

import S from './style.scss';

type PropsT = {
  passwordEvalRes: EvalPasswordStrengthResT;
  passwordsMatch: boolean | undefined;
};

export const PasswordResetChecks: FunctionComponent<PropsT> = ({
  passwordEvalRes,
  passwordsMatch,
}) => {
  const passwordCheckPills: ReactNode[] = [];
  for (let i = 0; i < 5; ++i) {
    let className = S.passwordCheckPill;
    if (i <= passwordEvalRes.strength) {
      className += passwordEvalRes.strength < 3 ? ` ${S.weak}` : ` ${S.strong}`;
    }
    passwordCheckPills.push(
      <div className={className} key={`password-check-pill-${i}`} />,
    );
  }

  return (
    <div styleName="passwordCheckBlock">
      <div styleName="passwordCheckPills">{passwordCheckPills}</div>
      <CheckItem pass={passwordEvalRes.has8Characters}>
        At least 8 characters
      </CheckItem>
      <CheckItem pass={passwordEvalRes.hasCasesAndDigits}>
        Must contain digits, lowercase and uppercase letters
      </CheckItem>
      <CheckItem pass={passwordEvalRes.hasNoForbidden}>
        Cannot contain your name or email address
      </CheckItem>
      <CheckItem pass={passwordsMatch}>
        Passwords must match
      </CheckItem>
    </div>
  );
};
